import { ref, computed } from 'vue';

// Estado compartilhado entre todos os componentes
const STORAGE_KEY = 'ob_editor_mode_active';
const editorModeActive = ref(false);

// Inicializa do localStorage
const initEditorMode = () => {
  const stored = localStorage.getItem(STORAGE_KEY);
  editorModeActive.value = stored === 'true';
};

// Toggle editor mode
const toggleEditorMode = () => {
  editorModeActive.value = !editorModeActive.value;
  localStorage.setItem(STORAGE_KEY, editorModeActive.value.toString());
  
  // Feedback discreto no console
  if (editorModeActive.value) {
    console.log('🎨 Editor mode ACTIVATED');
  } else {
    console.log('🎨 Editor mode DEACTIVATED');
  }
};

// Verifica se está ativo
const isEditorModeActive = computed(() => editorModeActive.value);

export function useEditorMode() {
  return {
    editorModeActive: isEditorModeActive,
    toggleEditorMode,
    initEditorMode
  };
}
